export const selectTickets = (state) => state.tickets.data.data;
export const selectTicketsFetching = (state) => state.tickets.data.fetching;
export const selectIsTicketCreateInProgress = (state) => state.tickets.data.isCreateInProgress;
export const selectNewTicketModalVisible = (state) => state.tickets.data.isModalVisible;
export const selectTicketsMeta = (state) => state.tickets.data.meta;
export const selectTicketsParams = (state) => state.tickets.data.params;
